<template>
  <span class="sensitive-decrypt">
    <template v-if="props.cipherText">
      {{ state.showPlain ? state.plainText || props.cipherText : maskText }}
      <LoadingOutlined v-show="state.loading" class="ml-4" style="font-size: 16px; color: var(--primary-color)" />
      <EyeTwoTone
        v-show="!state.loading && state.showPlain"
        @click="toggleShow"
        class="eye-icon"
        :two-tone-color="primaryColor"
      />
      <EyeInvisibleTwoTone
        v-show="!state.loading && !state.showPlain"
        @click="toggleShow"
        class="eye-icon"
        :two-tone-color="primaryColor"
      />
    </template>
    <template v-else>--</template>
  </span>
</template>

<script setup lang="ts" name="SensitiveDecrypt">
  import { reactive, computed } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone, LoadingOutlined } from '@ant-design/icons-vue'
  import { sensitiveService } from '@/service/api'
  import { useApi } from '@xinghai/site-common'
  import { isSuccess, getPrimaryColor } from '@/utils'

  interface Props {
    /** 密文/脱敏文本 */
    cipherText: string
    /** 记录ID */
    id: string | number
    /** 页面编码 */
    code: string
    /** 页面名称 */
    menuName: string
  }

  const props = defineProps<Props>()
  const primaryColor = getPrimaryColor()

  /** 脱敏显示文本 */
  const maskText = computed(() => {
    if (!props.cipherText) return '--'
    // 若服务端已脱敏则直接展示
    if (props.cipherText.includes('*')) return props.cipherText
    // 手机号默认脱敏规则
    return props.cipherText.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  })

  const state = reactive({
    /** 加载中 */
    loading: false,
    /** 显示明文 */
    showPlain: false,
    /** 明文结果 */
    plainText: ''
  })

  const decryptApi = useApi(sensitiveService.decrypt)

  /**
   * 切换显示/隐藏明文
   */
  const toggleShow = async () => {
    if (state.plainText) {
      state.showPlain = !state.showPlain
      return
    }
    state.loading = true
    try {
      const res = await decryptApi.fetchData({
        key: String(props.id),
        code: props.code,
        menuName: props.menuName
      })
      if (isSuccess(res)) {
        state.plainText = res.data
        state.showPlain = true
      }
    } finally {
      state.loading = false
    }
  }
</script>

<style lang="less" scoped>
  .sensitive-decrypt {
    .eye-icon {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
